import React, { useMemo, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './Directions.css';

const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  return /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && typeof window !== 'undefined' && 'ontouchend' in window);
};

const Directions = ({
  address = '123 Example St, Tampa, FL 33602',
  area = 'Westshore',
  label = 'Get Directions',
}) => {
  const [open, setOpen] = useState(false);

  const appleMapsUrl = useMemo(
    () => `https://maps.apple.com/?q=${encodeURIComponent(address)}`,
    [address]
  );

  const handleClick = () => {
    if (isIOS()) {
      window.location.href = appleMapsUrl;
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      {/* Hero background with card */}
      <section className="directions-hero">
        <div className="directions-overlay" />
        <div className="directions-hero-inner">
          <div aria-hidden="true" />
          <div className="directions-card">


            <p className="directions-card-title">
              <LocationOnIcon className="directions-pin" />
              {label}
            </p>
            <div className="directions-card-area">Located in {area}</div>
            <p className="directions-card-address">{address}</p>

            <Button
              variant="contained"
              className="directions-btn"
              onClick={handleClick}
            >
              {label}
            </Button>
          </div>
        </div>
      </section>

      {/* Popup */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
        classes={{ paper: 'custom-dialog-paper' }}
      >
        <DialogTitle className="dialog-title">
          
          <Button
            onClick={() => setOpen(false)}
            className="dialog-close-icon"
          >
            ✕
          </Button>
        </DialogTitle>

        <DialogContent>
          <div className="address-block">
            <div className="address-title">Address</div>
            <div className="address-text">{address}</div>
          </div>

          <div className="map-buttons">
            <Button
              variant="contained"
              className="map-btn google-maps-btn"
              onClick={() => window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`, '_blank')}
            >
              Open with Google Maps
            </Button>
            <Button
              variant="contained"
              className="map-btn apple-maps-btn"
              onClick={() => window.open(`https://maps.apple.com/?daddr=${encodeURIComponent(address)}`, '_blank')}
            >
              Open with Apple Maps
            </Button>
          </div>
        </DialogContent>
      </Dialog>

    </>
  );
};

export default Directions;
